(function () {
    "use strict";

    // @ngInject
    function WorkspaceFileStepPaymentControllerCtor(
            $scope, $stateParams, $injector, _, $q, $log, $state, NavigationService,
            AnalyticsService, WorkspaceFileService, ModalService, SetupGuideService,
            PopupMessageService, AppConfigService, PlaidLinkHelperService, PreviewModeService,
            AbTestService, Enums, WorkspaceFilesManager, WorkspaceService, $translate,
            UsersManager, AppStates, OnboardingService, RedirectService, $timeout, UserService,
            MobileAppService, DeviceService, InjectBrandingService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'WorkspaceFileStepPaymentController';

        this.isPreviewMode = PreviewModeService.isInPreviewMode();
        this.isOnboardingMode = $stateParams.isOnboardingInvoiceMode;
        this.$scope = $scope;
        this.$q = $q;
        this.$log = $log;
        this.NavigationService = NavigationService;

        // Services assignment
        this.SetupGuideService = SetupGuideService;
        this._ = _;
        this.RedirectService = RedirectService;
        this.OnboardingService = OnboardingService;
        this.WorkspaceFilesManager = WorkspaceFilesManager;
        this.WorkspaceFileService = WorkspaceFileService;
        this.WorkspaceService = WorkspaceService;
        this.PopupMessageService = PopupMessageService;
        this.AnalyticsService = AnalyticsService;
        this.AppStates = AppStates;
        this.ModalService = ModalService;
        this.AppConfigService = AppConfigService;
        this.workspaceFileId = $stateParams.workspace_file_id;
        this.UsersManager = UsersManager;
        this.PlaidLinkHelperService = PlaidLinkHelperService;
        this.user = UsersManager.getCurrUser();
        this.isExampleProposal = this.user.shouldShowExampleProposal();
        this.AbTestService = AbTestService;
        this.Enums = Enums;
        this.$translate = $translate;
        this.PreviewModeService = PreviewModeService;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$timeout = $timeout;
        this.MobileAppService = MobileAppService;
        this.InjectBrandingService = InjectBrandingService;

        this.isInAppBrowser = DeviceService.isInAppBrowser();

        this.workspaceFile = WorkspaceFilesManager.getWorkspaceFile(this.workspaceFileId);
        AnalyticsService.trackPageView(this, 'payments step',
            {
                preview_mode: this.isPreviewMode,
                file_mode: WorkspaceFileService.whichCurrentFileView(this.workspaceFile)
            }
        );

        this.showEditButton = true;
        this.isLoggedInAsClient = false;
        this.showAddCardForm = false;
        this.addCardAndMakingPaymentInProcess = false;
        this.autopayAgreed = false;
        this.initPaymentTabs();

        this.showAddAdyenAchMethodDropIn = false;

        PreviewModeService.setState('payment');

        var self = this;

        this.isLoggedInAsClient = this.user.client_login_file_id && this.user.client_login_file_id === this.workspaceFile._id;

        // redirect if there are not payments to pay
        if (this.workspaceFile.payments_container.isFullyPaid() && !this.isLoggedInAsClient) {
            this.AnalyticsService.track(this.$scope, this.AnalyticsService.analytics_events.access_payments_when_fully_paid,
                {
                    workspace_file: this.workspaceFile._id
                });
            this.goToState(this.AppStates.root_core_navigation_event_workspace_files, {workspace_id: this.workspaceFile.couple_card_id, event_id: this.workspaceFile.event._id});
        }

        this.noTip = {value: 0, label: 'FILE.PAYMENT._NO_THANKS_'};
        this.customTip = {value: '', label: 'FILE.PAYMENT._CUSTOM_TIP_'};
        this._updateTips();
        this.currentTip = this.noTip;

        if (this.workspaceFile.file_type !== undefined) {
            // we dont want to wait for the update to load the film strip, cause it causes a blick in the ui when
            // moving between states
            this.loadFilmStrip();
        }

        this.onEditPaymentMethodMode = !!this.$stateParams.editCardMode;

        this.setupCurrentPaymentModel();
        this.paymentNumberBeforeSuccess = this.paymentNumber;
        this.register(this.workspaceFile, 'success', function success() {
            this.gotWorkspaceFile();

            // redirect if you are not the client
            if (!this.isPreviewMode && this.user._id === this.workspaceFile.owner._id || this.workspaceFile.isViewOnlyMode()) {
                this.WorkspaceFileService.gotoWorkspaceFileView(this.workspaceFile, null, true);
            }

            // redirect if there are not payments to pay
            if (this.workspaceFile.payments_container.isFullyPaid() && !this.isLoggedInAsClient) {
                this.goToState(this.AppStates.root_core_navigation_event_workspace_files, {workspace_id: this.workspaceFile.couple_card_id, event_id: this.workspaceFile.event._id});
            }

            // We want to recalculate the payment details because when the model is updated
            this.setupCurrentPaymentModel();
        });

        this.register(this.workspaceFile, 'error', function error(message) {
            if (this.alreadyGotFile) {
                return;
            }
            if (!message) {
                message = 'FILE.ALERTS._UNABLE_TO_LOAD_MESSAGE_';
            }

            this.PopupMessageService.showAlert(PopupMessageService.severityTypes.info, message, function success() {
                this.goToState(self.AppStates.root_core_navigation_dashboard);
            }.bind(this));
        });

        this.setupPaymentMethodsModel();
        this.isDeletePaymentMethodMode = false;
        this.hasError = false;
        this.showOverallLoader = true;

        this.isAddCreditCardFormValid = false;
        $scope.$watch('workspaceFileStepPaymentVm.addPayFormValid', function (newVal, oldVal) {
            if(!angular.equals(newVal, oldVal)){
                this.validationFromAddCreditCard(newVal);
            }
        }.bind(this), true);

        $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            UserService.onBookInPersonStateChange(event, toState);
        }.bind(this));

        if(this.isInAppBrowser) {
            this.MobileAppService.triggerAppEvent(this.MobileAppService.OUTBOUND.file_step_active, {step: 'pay'});
        }
    }


    Controllers.WorkspaceFileStepPaymentController = Class(Controllers.BaseController, {

        constructor: WorkspaceFileStepPaymentControllerCtor,

        _updateTips: function _updateTips() {
            this.tipOptions = [
                {value: Math.round(this.workspaceFile.getTotalProposalValue() * 0.05), label: '5'},
                {value: Math.round(this.workspaceFile.getTotalProposalValue() * 0.10), label: '10'},
                {value: Math.round(this.workspaceFile.getTotalProposalValue() * 0.15), label: '15'}
            ];
        },

        onSavePaymentMethod: function onSavePaymentMethod() {
            var paymentMethod = this.getSelectedPaymentMethod();
            var shouldCreateCard = (!paymentMethod || paymentMethod._type === 'PaymentMethodStripeCard') && !this.getCreditCardsCount();

            if (shouldCreateCard) {
                this.processingRequest = true;
                this.$scope.$broadcast('addCard');
            } else {
                this._editRecurringPaymentMethod();
            }
        },

        initPaymentTabs: function initPaymentTabs() {
            switch (this.workspaceFile.accepted_payment_method) {
                case this.Enums.PaymentMethods.creditCard:
                    this.achComponentTabs = [{name: 'Credit Card'}];
                    break;

                case this.Enums.PaymentMethods.bankAccount:
                    this.achComponentTabs = [{name: 'Bank Transfer'}];
                    break;

                default:
                case null:
                    this.achComponentTabs = [{name: 'Bank Transfer'}, {name: 'Credit Card'}];
                    break;
            }

            if (this.workspaceFile.accepted_payment_method) {
                this.activePaymentTab = this.achComponentTabs[0].name; // credit card or ach tab
            } else {
                this.activePaymentTab = this.achComponentTabs[1].name; // credit card or ach tab
            }


            this.achStates = [
                {name: 'list'},
                {name: 'select'}
            ];
            this.activeAchState = this.achStates[0].name; // list ach accounts or select ach account

        },

        gotWorkspaceFile: function gotWorkspaceFile(message, status) {

            if(this.workspaceFile.company){

                this.InjectBrandingService.setBrandColorVars(this.workspaceFile.company.brand_color);
            }

            this.autopayActive = this.workspaceFile.payments_container.auto_payment && this.workspaceFile.payments_container.auto_payment.status === this.Enums.AutoPaymentStatus.active;
            this.autoPaymentByVendor = this.workspaceFile.payments_container.isAutoPayByVendor();
            this.shouldShowAutoPayment = (!this.currentPayment.isLastPayment() || this.autopayActive) && !this.isLoggedInAsClient;
            this.isRecurringPayment = this.workspaceFile.payments_container.isRecurringPayment();
            this.shouldShowRecurringPayment = this.currentPayment.isFirstPayment() && this.isRecurringPayment && !this.workspaceFile.isRecurringPaymentAccepted();
            this.shouldUpdateRecurringPaymentMethod = this.isRecurringPayment && this.workspaceFile.isRecurringPaymentAccepted();

            if (!this.isPreviewMode && !this.isOwnerMode && !this.alreadyGotFile) {
                this.WorkspaceFilesManager.updateStatus(this.workspaceFile, this.WorkspaceFileService.fileStatuses.payments_seen);
            }

            this.enableAch = this.workspaceFile.isPaymentMethodAccepted(this.Enums.PaymentMethods.bankAccount);

            if (this.enableAch && this.workspaceFile.owner.company.useStripePaymentGateway()) {
                this.PlaidLinkHelperService.lazyInit(); // We can call it many times. It will only run once.
                this.setupBankAccountModel();
            }

            this.isOwnerMode = this.workspaceFile.isOwnerMode();
            this.isClientMode = this.workspaceFile.isClientMode();
            this.alreadyGotFile = true;

            this.loadFilmStrip();
            this.showOverallLoader = false;

            this._updateTips();
            this._setHeaderImage();
        },

        _setHeaderImage: function  _setHeaderImage(){
            if (this.workspaceFile.workspace_file_header_icon){
                this.headerImage = this.workspaceFile.workspace_file_header_icon;
                this.isHeaderIconImage = true;
            } else {
                this.headerImage =  this.workspaceFile.company.icon_image.url;
            }
        },

        loadFilmStrip: function loadFilmStrip() {
            if (this.filmStripLoaded === true) {
                return;
            }

            this.filmStripLoaded = true;
            this.linksTo = this.WorkspaceFileService.getFilmstripLinksForWorkspace(
                this.workspaceFile, this.isExampleProposal, 'pay', this.$stateParams);
        },

        showAddAchMethod: function showAddAchMethod() {
            if (this.enableAch && this.workspaceFile.owner.company.useStripePaymentGateway()) {
                this.plaidShow();
            } else {
                this.showAdyenAddAchMethod(true);
            }

        },

        showAdyenAddAchMethod: function showAdyenAddAchMethod(is_show) {
            this.showAddAdyenAchMethodDropIn = is_show;
        },

        plaidShow: function plaidShow() {
            if (this.isPreviewMode) {
                return;
            }
            this.achBankAccounts = [];
            this.showAchBankAccountsLoader = true;
            this.PlaidLinkHelperService.openPlaidDialog().then(
                function plaidSuccess(token) {
                    this.AnalyticsService.trackSuccess(this.$scope, this.AnalyticsService.analytics_events.add_bank_account);
                    this.activeAchState = this.achStates[1].name;
                    this.UsersManager.setupBankAccount(this.user, token, this.PlaidLinkHelperService.currInstitutionId).then(
                        function setupBankAccount(res) {
                            this.achBankAccounts = res.data;
                            this.selectedNewAccount = this.achBankAccounts[0];
                            this.showAchBankAccountsLoader = false;
                        }.bind(this),
                        function failedSetupBankAccount(res) {
                            var message;
                            if (res && res.data && res.data.error_type) {
                                if (res.data.error_type === 'HBPlaidUserError') {
                                    message = res.data.error_message;
                                } else {
                                    message = 'ERRORS.SERVER_API._UNEXPECTED_';
                                }
                            } else {
                                message = 'ERRORS.SERVER_API._UNEXPECTED_';
                            }
                            this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, message);
                            this.$log.error('error fetching bank account list from plaid', res);
                            this.showAchBankAccountsLoader = false;

                            // go back to the add account or credit card state
                            this.cancelAchAccountSelection();
                        }.bind(this)
                    );
                    // res contains the bank accounts available for this user.
                }.bind(this),
                function plaidFailure(error) {
                    this.AnalyticsService.trackError(this.$scope, this.AnalyticsService.analytics_events.add_bank_account, {}, error);
                }.bind(this));
        },

        selectPaymentTab: function selectPaymentTab(tabName) {
            this.hasError = false;
            if (this.activePaymentTab !== tabName) {
                this.activePaymentTab = tabName;
                this.isDeletePaymentMethodMode = false;
                this.showAddCardForm = false;
                // this.showEditButton = this.hasSelectedPaymentMethod();
                this.showAddAdyenAchMethodDropIn = false;
            }
        },

        setSelectedNewAccount: function setSelectedNewAccount(account) {
            this.selectedNewAccount = account;
        },

        setSelectedCurrentAccount: function setSelectedCurrentAccount(account) {
            if (this.isDeletePaymentMethodMode) {
                var analyticsParams = {payment_method_id: account._id, method_type: account._type, credit_card_name: account.name};
                this.AnalyticsService.track(this.$scope, 'click: ' + this.AnalyticsService.analytics_events.bank_account_deleted, analyticsParams);
                this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.info, 'FILE.PAYMENT.ALERT._CONFIRM_DELETE_',
                    this.deleteAccountMethod.bind(this, account), undefined, undefined, undefined, undefined, true);
            }
            this.selectedCurrentAccount = account;
            // this.showEditButton = this.hasSelectedPaymentMethod();
        },

        submitAchAccountSelection: function submitAchAccountSelection(account) {
            this.activeAchState = this.achStates[0].name;
            this.showOverallLoader = true;

            if (!this.selectedNewAccount) {
                return;
            }

            this.UsersManager.createChargeableBankAccount(this.user, this.selectedNewAccount, null, null).then(
                function successCreatingBankAccount() {
                    this.setupBankAccountModel();
                    this.$log.info('success in creating the bank account payment method');
                }.bind(this),
                function errorCreatingBankAccount(res) {
                    if (res.data && res.data.error) {
                        this.errorMessage = res.data.error_message;
                        this.hasError = true;
                    }
                    this.$log.error('error creating chargeable bank account', arguments);
                }.bind(this)
            ).finally(function finallyCallback() {
                this.showOverallLoader = false;
            }.bind(this));

        },

        cancelAchAccountSelection: function cancelAchAccountSelection(account) {
            this.activeAchState = this.achStates[0].name;
        },

        continueToPayment: function continueToPayment() {

            this.working = true;
            var promise = this.WorkspaceFilesManager.updateStatus(this.workspaceFile, this.WorkspaceFileService.fileStatuses.payments_seen);

            promise.then(function success() {
                this.WorkspaceFileService.gotoWorkspaceFileView(this.workspaceFile);
            }.bind(this));

            promise.finally(function fulfilled() {
                this.working = false;
            }.bind(this));
        },

        getProposalLabel: function getProposalLabel() {
            return this.WorkspaceFileService.getProposalLabel(this.workspaceFile);
        },

        setupCurrentPaymentModel: function setupCurrentPaymentModel() {
            // position field is not accessible yet
            var nonPaidPayments = [];
            this.workspaceFile.payments_container.payments.forEach(function (payment) {
                if (!payment.is_paid && !payment.is_pending) {
                    nonPaidPayments.push(payment);
                }
            });
            nonPaidPayments = this._.sortBy(nonPaidPayments, function (payment) {
                return payment.due_date;
            });
            if (nonPaidPayments.length === 0) {
                // There are no payments left to pay so we're going to the summary view
                this.WorkspaceFileService.gotoWorkspaceFileSummary(this.workspaceFileId);
            }
            this.currentPayment = nonPaidPayments[0];
            var hasUnpaidPayments = nonPaidPayments.length > 0;
            var notFirstUnpaid = nonPaidPayments.length > 0 && !this.currentPayment.isFirstPayment();
            var isOnlyPayment = this.workspaceFile.payments_container.payments.length === 1;
            this.showGratuity = this.workspaceFile.allow_gratuity && (this.isPreviewMode || (hasUnpaidPayments && (notFirstUnpaid || isOnlyPayment)));
            this.paymentNumber = this.workspaceFile.payments_container.payments.length + 1 - nonPaidPayments.length;
            this.totalPrice = this.workspaceFile.getTotalProposalValue();

            this.paymentsLeft = this.workspaceFile.payments_container.payments.length - this.paymentNumber;
        },

        setupPaymentMethodsModel: function setupPaymentMethodsModel() {
            var methods = this.user.payment_methods.filter(function (method) {
                return method._type === 'PaymentMethodStripeCard' || method._type === 'PaymentMethodAdyenCard';
            });
            if (methods.length > 0) {
                this.currentPaymentMethod = methods[methods.length - 1];
            } else {
                this.currentPaymentMethod = undefined;
            }

            // this.showEditButton = this.hasSelectedPaymentMethod();
        },

        getCreditCardsCount: function getCreditCardsCount() {
            return this.getCreditCards().length;
        },

        getCreditCards: function getCreditCards() {
            if (this.isPreviewMode) {

                this.dummyCreditCard = this.dummyCreditCard || {
                    _id: '123abc',
                    type: 'MasterCard',
                    last4: 'test'
                };

                this.selectPaymentMethod(this.dummyCreditCard);

                return [this.dummyCreditCard];
            }

            return this.user.payment_methods.filter(function (method) {
                return method._type === 'PaymentMethodStripeCard' || method._type === 'PaymentMethodAdyenCard';
            });
        },

        getBankAccounts: function getBankAccounts() {
            if (this.isPreviewMode) {

                this.dummyBankAccount = this.dummyBankAccount || {
                    _id: '456fde',
                    subtype: 'test',
                    last4: '9898'
                };

                this.setSelectedCurrentAccount(this.dummyBankAccount);

                return [this.dummyBankAccount];
            }

            return this.user.payment_methods.filter(function (method) {
                return method._type === 'PaymentMethodChargeableBankAccount' || method._type === 'PaymentMethodAdyenBankAccount';
            });
        },

        openAddCardForm: function openAddCardForm() {
            this.hasError = false;
            if (!this.isPreviewMode) {
                this.showAddCardForm = true;
            }
            this.closeExpirationDateTooltip();
        },

        closeAddCardForm: function closeAddCardForm() {
            this.showAddCardForm = false;
        },

        successAddCardForm: function successAddCardForm(paymentMethodId) {
            this.isDeletePaymentMethodMode = false;
            this.setupPaymentMethodsModel();
            this.closeAddCardForm();
            this.showAdyenAddAchMethod(false);
            this._trackNewCreditCard(paymentMethodId);
            if (this.shouldUpdateRecurringPaymentMethod) {
                this._editRecurringPaymentMethod();
            }
        },

        successAddAchForm: function successAddAchForm(paymentMethodId) {
            this.isDeletePaymentMethodMode = false;
            this.setupPaymentMethodsModel();
            this.showAdyenAddAchMethod(false);
            if (this.shouldUpdateRecurringPaymentMethod) {
                this._editRecurringPaymentMethod();
            }
        },

        successAddCardSubmitFirstPayment: function successAddCardSubmitFirstPayment() {
            this.successAddCardForm();
            this._internalCharge();
        },

        failedAddCardSubmitFirstPayment: function failedAddCardSubmitFirstPayment() {
            this.addCardAndMakingPaymentInProcess = false;
        },

        setupBankAccountModel: function setupBankAccountModel() {
            if (this.enableAch) {
                var methods = this.user.payment_methods.filter(function (method) {
                    return method._type === 'PaymentMethodChargeableBankAccount';
                });

                if (methods.length > 0) {
                    this.selectedCurrentAccount = methods[methods.length - 1];
                } else {
                    this.selectedCurrentAccount = null;
                }
            }

            // this.showEditButton = this.hasSelectedPaymentMethod();
        },

        selectPaymentMethod: function selectPaymentMethod(method) {
            if (this.isDeletePaymentMethodMode) {
                var analyticsParams = {payment_method_id: method._id, method_type: method._type, credit_card_name: method.name};
                this.AnalyticsService.track(this.$scope, 'click: ' + this.AnalyticsService.analytics_events.delete_credit_card, analyticsParams);
                this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.info, 'FILE.PAYMENT.ALERT._CONFIRM_DELETE_',
                    this.deletePaymentMethod.bind(this, method), undefined, undefined, undefined, undefined, true);
            } else {
                this.currentPaymentMethod = method;
            }

            // this.showEditButton = this.hasSelectedPaymentMethod();
        },

        deletePaymentMethod: function deletePaymentMethod(method) {
            var promise = this.user.deletePaymentMethod(method._id);
            var analyticsParams = {payment_method_id: method._id, method_type: method._type, credit_card_name: method.name};
            promise.then(
                function success() {
                    this.AnalyticsService.trackSuccess(this.$scope, this.AnalyticsService.analytics_events.delete_credit_card, analyticsParams);
                    this.setupPaymentMethodsModel();
                    this.setupBankAccountModel();
                }.bind(this),
                function canceled() {
                    this.AnalyticsService.trackCancel(this.$scope, this.AnalyticsService.analytics_events.delete_credit_card, analyticsParams);
                }.bind(this)
            );

        },

        deleteAccountMethod: function deleteAccountMethod(method) {
            var promise = this.user.deletePaymentMethod(method._id);
            var analyticsParams = {payment_method_id: method._id, method_type: method._type, credit_card_name: method.name};
            promise.then(
                function success() {
                    this.AnalyticsService.trackSuccess(this.$scope, this.AnalyticsService.analytics_events.bank_account_deleted, analyticsParams);
                    this.setupPaymentMethodsModel();
                    this.setupBankAccountModel();
                }.bind(this),
                function canceled() {
                    this.AnalyticsService.trackCancel(this.$scope, this.AnalyticsService.analytics_events.bank_account_deleted, analyticsParams);
                }
            );

        },

        hasSelectedPaymentMethod: function hasSelectedPaymentMethod() {
            return !!this.getSelectedPaymentMethod();
        },

        getSelectedPaymentMethod: function getSelectedPaymentMethod() {
            if (this.enableAch) {
                if (this.activePaymentTab === this.achComponentTabs[0].name) { // PAY WITH BANK ACCOUNT
                    return this.selectedCurrentAccount;
                } else if (this.activePaymentTab === this.achComponentTabs[1].name) { // PAY WITH CREDIT CARD
                    return this.currentPaymentMethod;
                }
            } else { // PAY WITH CREDIT CARD
                return this.currentPaymentMethod;
            }
        },

        _doneOnbordingInvoice: function _doneOnbordingInvoice() {
            this.ModalService.openDoneInvoiceOnboardingModal(this.workspace, this.workspaceFile);
        },

        _openClientExperienceConfirmAutomaticPaymentsPopup: function _openClientExperienceConfirmAutomaticPaymentsPopup() {
            return this.PopupMessageService.showConfirmWithDontShowAgainPromise(
                this.PopupMessageService.severityTypes.none,
                'FILE.PAYMENT._PREVIEW_MODE_AUTOMATIC_PAYMENTS_COPY_',
                null,
                'FILE.PAYMENT._PREVIEW_MODE_AUTOMATIC_PAYMENTS_CTA_',
                null, // 'Cancel' by default
                null, // Not using UI Persistence (checkbox hidden in CSS)
                'file-preview-hb-popup' // But we are using CSS class
            );
        },

        _openClientExperienceCompletePopup: function _openClientExperienceCompletePopup() {
            return this.PopupMessageService.showConfirmPromise(
                this.PopupMessageService.severityTypes.none,
                'FILE.PAYMENT._PREVIEW_MODE_TEST_DONE_',
                this.isOnboardingMode ? 'FILE.HEADER._DONE_' : 'FILE.PAYMENT._RETURN_TO_FILE_',
                null, // 'Cancel' by default
                'FILE.PAYMENT._PREVIEW_MODE_TITLE_DONE_',
                undefined,
                undefined,
                undefined,
                undefined,
                true
            );
        },

        _handleClientExperiencePopupConfirm: function _handleClientExperiencePopupConfirm() {
            this.AnalyticsService.trackClick(this, 'confirm return to file');
            if (this.isOnboardingMode) {
                this._doneOnbordingInvoice();
            } else if (this.PreviewModeService.shouldExplicitlyExitPreviewtoEditFile) {
                this.PreviewModeService.returnToFile(this.workspaceFile, this.$state.params, true);
            } else {
                this.NavigationService.goHistoryBack();
            }
        },

        _handleClientExperiencePopupReject: function _handleClientExperiencePopupReject() {
            this.AnalyticsService.trackClick(this, 'dismissed return to file');
        },

        getActivateAutoPayment: function getActivateAutoPayment() {
            return this.autopayAgreed || this.autopayActive;
        },

        getActivateRecurringPayment: function getActivateRecurringPayment() {
            return this.shouldShowRecurringPayment && this.recurringPaymentAgreed;
        },

        _internalCharge: function _internalCharge() {

            if (this.isPreviewMode) {
                if (this.autopayAgreed) {
                    this._openClientExperienceConfirmAutomaticPaymentsPopup()
                    .then(this._openClientExperienceCompletePopup.bind(this))
                    .then(this._handleClientExperiencePopupConfirm.bind(this))
                    .catch(this._handleClientExperiencePopupReject.bind(this));
                    return;
                } else {
                    this._openClientExperienceCompletePopup()
                    .then(this._handleClientExperiencePopupConfirm.bind(this))
                    .catch(this._handleClientExperiencePopupReject.bind(this));
                    return;
                }
            }

            var method = this.getSelectedPaymentMethod();

            if (!method) {
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info,
                    'FILE.PAYMENT.ALERT._NO_CARD_SELECTED_');
                return;
            }

            var analyticsProperties = {
                method_type: method._type,
                credit_card_name: method.name,
                payment_tip: this.currentTip.value
            };

            this.AnalyticsService.track(this.$scope, 'click: ' + this.AnalyticsService.analytics_events.payment_paid, analyticsProperties);

            this.errorMessage = false;
            this.processingRequest = true;
            this.currentPaymentId = this.currentPayment._id;

            // For GA tracking
            var oldStatus = this.workspaceFile.status_cd;
            var gaLabel = this.paymentNumber + '/' + this.workspaceFile.payments_container.payments.length;
            var gaAmount = this.currentPayment.amount;

            var promise = this.workspaceFile.payPayment(
                this.currentPayment,
                method,
                (this.currentTip.value || 0),
                this.getActivateAutoPayment(),
                this.isLoggedInAsClient,
                this.getActivateRecurringPayment());
            promise.then(function success(resp) {
                try {
                    this.AnalyticsService.trackSuccess(this.$scope, this.AnalyticsService.analytics_events.payment_paid, analyticsProperties);

                    var receiptStateParams = this.AppConfigService.receiptState();
                    receiptStateParams.workspaceFile = resp.model;
                    receiptStateParams.paymentId = this.currentPaymentId;

                    if (receiptStateParams.workspaceFile.file_type_cd === this.WorkspaceFileService.fileTypes.invoice &&
                        oldStatus !== this.WorkspaceFileService.fileStatuses.retainer_paid &&
                        receiptStateParams.workspaceFile.status_cd === this.WorkspaceFileService.fileStatuses.retainer_paid) {

                        var dateDiff = Math.round((Date.now() - Date.parse(resp.data.sent_on)) / (1000 * 60 * 60 * 24));
                    }

                    this.addCardAndMakingPaymentInProcess = false;

                } catch(err) {
                    // do nothing, error should appear in trackjs and we don't want transfer to appear as if failed
                } finally {
                    // always go to receipt, we remove the setup page
                    this.goToState(this.AppStates.root_core_receipt, {isLoggedInAsClient: this.isLoggedInAsClient}, {location: false});
                }
            }.bind(this))
            .catch(function failure(resp) {
                if (resp.data && resp.data.error_message) {
                    if (resp.data.error_type === "HistoryVersionError") {
                        var file = null;
                        // Get the new file and resolve a promise to know when it's done
                        var getFilePromise = this.$q(function getFileQueue(resolve, reject) {
                            file = this.WorkspaceFilesManager.getWorkspaceFile(this.workspaceFileId);
                            this.registerOnce(file, 'success', function success() {
                                resolve();
                            });
                            this.registerOnce(file, 'error', function error() {
                                reject();
                            });
                        }.bind(this));

                        // show an error message and resolve a promise when it's done
                        var messagePromise = this.$q(function messageAlertQueue(resolve, reject) {
                            this.PopupMessageService.showAlertWithCloseCallback(this.PopupMessageService.severityTypes.warning, resp.data.error_message, function popupClose() {
                                resolve();
                            });
                        }.bind(this));

                        this.$q.all([getFilePromise, messagePromise]).finally(function allPromisesDone() {
                            this.WorkspaceFileService.gotoWorkspaceFileView(file);
                        }.bind(this));
                    }
                    else if (resp.data.error_type === 'HBStripeCardDeclinedError') {
                        this.errorMessage = this.$translate.instant('FILE.PAYMENT.ERRORS._CARD_DECLINED_');
                    }
                    else {
                        this.errorMessage = resp.data.error_message;
                    }
                } else {
                    this.errorMessage = 'Unknown error has occurred';
                }

                this.hasError = true;
                this.addCardAndMakingPaymentInProcess = false;

            }.bind(this))
            .finally(function complete() {
                this.processingRequest = false;
            }.bind(this));

        },

        _editRecurringPaymentMethod: function _editRecurringPaymentMethod() {
            this.processingRequest = true;

            this.workspaceFile.updateRecurringPaymentMethod(this.getSelectedPaymentMethod()._id).then(function() {
                this.$state.go(this.$state.previous.route.name, this.$state.previous.routeParams);
            }.bind(this)).finally(function() {
                this.processingRequest = false;
            }.bind(this));
        },

        _addCardTooltip: function _addCardTooltip() {
            this.$timeout(function () {
                this.expirationDateAddNewCard = true;
            }.bind(this), 500);
        },

        closeExpirationDateTooltip: function closeExpirationDateTooltip() {
            this.expirationDateAddNewCard = false;
        },

        onPayWithExistingCard: function onPayWithExistingCard() {
            var paymentMethod = this.getSelectedPaymentMethod();
            this.hasError = false;

            if (!this._isNewCreditCard(paymentMethod._id) && paymentMethod._type === 'PaymentMethodStripeCard') {
                this.ModalService.openCreditCardConfirmModal(paymentMethod)
                    .then(function (res) {
                        switch (true){
                            case res.valid:
                                this.onPayClick();
                                break;
                            case res.addNewCard:
                                this._addCardTooltip();
                                break;
                        }
                    }.bind(this));
            } else {
                this.onPayClick();
            }
        },

        onPayClick: function onPayClick() {
            var promise = this.$q.when();
            var isAutopay = this.autopayAgreed;
            var paymentMethod = this.getSelectedPaymentMethod();
            var addCard = (!paymentMethod || paymentMethod._type === 'PaymentMethodStripeCard') && !this.getCreditCardsCount();
            var analProps = {
                auto_pay: isAutopay,
                add_card: addCard,
                payment_tip: this.currentTip.value || null,
                preview_mode: this.isPreviewMode,
                payment_method_type: paymentMethod ? (paymentMethod._type === "PaymentMethodStripeCard" ? 'credit card' : 'bank transfer') : 'new card',
                payment_method: paymentMethod ? paymentMethod._type : ''
            };

            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.pay, analProps);

            // auto pay
            if (isAutopay && !this.autoPaymentByVendor) {
                if (this.isPreviewMode) {
                    this._openClientExperienceConfirmAutomaticPaymentsPopup()
                    .then(this._openClientExperienceCompletePopup.bind(this))
                    .then(this._handleClientExperiencePopupConfirm.bind(this))
                    .catch(this._handleClientExperiencePopupReject.bind(this));
                    return;
                }
                promise = this.ModalService.openConfirmAutoPayModal(false);
            }

            promise.then(function ok() {

                if (addCard) {
                    this.$scope.$broadcast('AddCardAndPay');
                    this.addCardAndMakingPaymentInProcess = true;
                }
                else {
                    this._internalCharge();
                }

            }.bind(this));
        },

        setTip: function setTip(tip, inputId) {
            this.currentTip = tip;
            if (inputId) {
                angular.element('#' + inputId).focus();
                this.shouldShowDollarSign = true;
                this.currentTipFocused = true;
            }
        },

        onCustomTipBlur: function onCustomTipBlur() {
            this.shouldShowDollarSign = false;
            this.currentTipFocused = false;

            if (this.customTip.value > 0 ){
                this.shouldShowDollarSign = true;
            } else {
                this.shouldShowDollarSign = false;
            }
        },

        calculateTotal: function calculateTotal() {
            return (this.currentPayment !== undefined ? this.currentPayment.amount + (this.currentTip.value || 0) : 0);
        },

        analyticsProperties: function analyticsProperties() {
            return this.WorkspaceFileService.generateAnalyticsProps(this.workspaceFile);
        },

        openIntakeModal: function openIntakeModal() {
            this.ModalService.openIntakeModal().then(
                this.onIntakeModalSubmission.bind(this));
        },

        onIntakeModalSubmission: function onIntakeModalSubmission() {
            this.isExampleProposal = false;

            var userRequest = this.UsersManager.forceFetchCurrUser();

            var redirect = userRequest.then(function() {
                this.RedirectService.redirect(this.user);
            }.bind(this));
        },

        validationFromAddCreditCard: function validationFromAddCreditCard(res) {
            this.isAddCreditCardFormValid = res;
        },

        autopayValid: function autopayValid() {
            return this.autopayActive || (this.autoPaymentByVendor ? this.autopayAgreed : true);
        },

        allowPay: function allowPay() {
            return (this.isPreviewMode || this.currentPayment.allowPay()) &&
                this.autopayValid() &&
                (!this.shouldShowRecurringPayment || this.recurringPaymentAgreed);
        },

        hasPaymentMethod: function hasPaymentMethod() {
            if (this.activePaymentTab === 'Credit Card') {
                return this.getCreditCardsCount() > 0;
            }

            return this.getBankAccounts().length > 0;
        },

        _trackNewCreditCard: function _trackNewCreditCard(paymentMethodId) {
            this.newPaymentMethods = this.newPaymentMethods || [];
            this.newPaymentMethods.push(paymentMethodId);
        },

        _isNewCreditCard: function _isNewCreditCard(paymentMethodId) {
            this.newPaymentMethods = this.newPaymentMethods || [];
            return this.newPaymentMethods.indexOf(paymentMethodId) !== -1;
        }
    });
}());
